export const ADD_REPORT = 'ADD_REPORT'
export const REMOVE_REPORT = 'REMOVE_REPORT'
export const CLEAR_REPORTS = 'CLEAR_REPORTS'
export const GET_HOLIDAYS= 'GET_HOLIDAYS'
export const SET_HOLIDAYS= 'SET_HOLIDAYS'
export const COUNT_HOLIDAYS= 'COUNT_HOLIDAYS'
export const UPDATE_REPORT_RECORD_VALUE= 'UPDATE_REPORT_RECORD_VALUE'

